import { Component } from '@angular/core';

@Component({
    selector: 'app-register_user',
    templateUrl: 'register_user.component.html',
    styleUrls: ['register_user.component.css'],
    standalone: false
})
export class Register_userComponent {
  constructor() {
  }
}
